module.exports = __webpack_public_path__ + "img/zeta.c40cf7e6.svg";